import PropTypes from 'prop-types'
import { ConfirmationDialog } from 'components'

import helpers from 'helpers'

import * as service from 'service'

import useSnackbar from 'hooks/useSnackbar'

const DestroyChurnReason = ({
  churnReason,
  refresh = () => {},
  open = false,
  setOpen = () => {},
}) => {
  const snackbar = useSnackbar()

  const handleDestroy = async () => {
    try {
      await service.dponet.churnReasons.destroy({
        churnReasonId: churnReason?.id,
      })
      refresh()

      snackbar.open({
        message: 'Motivo de churn excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao excluir o motivo de churn.',
      })
    }
    setOpen(false)
  }

  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      message="Deseja realmente excluir o motivo de churn?"
      cancelButtonText="Cancelar"
      buttonText="Confirmar"
      actionAcceptButton={handleDestroy}
    />
  )
}

DestroyChurnReason.propTypes = {
  churnReason: PropTypes.object.isRequired,
  refresh: PropTypes.func,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
}

export default DestroyChurnReason
